import store from "@/store";
import { computed, onMounted, onUnmounted } from "vue";
const useRooms = () => {
    onMounted(async () => store.dispatch.rooms.subscribe());
    onUnmounted(async () => store.dispatch.rooms.unsubscribe());
    return {
        rooms: computed(() => store.state.rooms.config),
        roomNameFromId: (roomId) => store.getters.rooms.roomName(roomId),
        setRFID: store.dispatch.rooms.setRFID
    };
};
export default useRooms;
